// Percorso: static/pleiadi_composer/js/components/magnetic_card/init_magnetic_card.js

export function initMagneticCardPlugin() {
    // Controlliamo se esiste l'hook nel DOM
    if (document.querySelector('.js-magnetic-card')) {

        // Catena di caricamento:
        // 1. Carica Anime.js (Vendor)
        // 2. Carica la logica specifica (magnetic_card.js)
        // 3. Esegue la funzione default

        import('animejs')
            .then(() => import('./magnetic_card.js'))
            .then(module => {
                // Avvia la logica passando l'oggetto globale anime appena caricato
                module.default();
            })
            .catch(err => console.error("Pleiadi Composer: Error loading Magnetic Card", err));
    }
}
